export const featuresData = [
  {
    icon: "fas fa-shield-alt",
    iconUnicode: "\\f3ed",
    title: "100% Private & Secure",
    description:
      "All your data stays on your device. Nothing is uploaded or shared externally.",
    bgColor: "#eef6ff",
    iconColor: "#3b82f6",
  },
  {
    icon: "fas fa-magic",
    iconUnicode: "\\f0d0",
    title: "AI Resume Customization*",
    description:
      "AI adapts your resume to each job description for higher match rates.",
    bgColor: "#ede9fe",
    iconColor: "#8b5cf6",
  },
  {
    icon: "fas fa-file-alt",
    iconUnicode: "\\f15c",
    title: "ATS-Optimized Applications",
    description:
      "Applications use recruiter-friendly formats and are fully ATS-compatible.",
    bgColor: "#e0f2fe",
    iconColor: "#0ea5e9",
  },
  {
    icon: "fas fa-rocket",
    iconUnicode: "\\f135",
    title: "Automated Applications",
    description:
      "Applies to multiple jobs daily, guided by your saved preferences and profile details.",
    bgColor: "#dbeafe",
    iconColor: "#60a5fa",
  },
  {
    icon: "fas fa-cogs",
    iconUnicode: "\\f085",
    title: "Simple Setup",
    description:
      "Install the extension, upload your resume, and start job automation within minutes.",
    bgColor: "#fef3c7",
    iconColor: "#f59e0b",
  },
  {
    icon: "fas fa-brain",
    iconUnicode: "\\f5dc",
    title: "Smart Question Handling",
    description:
      "AI fills common screening questions automatically, saving you time during applications.",
    bgColor: "#d1fae5",
    iconColor: "#10b981",
  },
];
